export const genericFunction = value => () => value
